import { Box, Card, Divider, Grid, IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import Iconify from '../../../../../../reusable-components/iconify/Iconify';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormTitle from '../../../FormFields/FormTitle';
import FormVendorField from '../../../FormFields/FormVendorField';
import FormVendorFieldWithAddMore from '../../../FormFields/FormVendorFieldWithAddMore';
import { formCardStyle } from '../../../TransitionStyles';

VendorsSectionCard.propTypes = {
  title: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  permissions: PropTypes.object,
};

export default function VendorsSectionCard({ title, fields, permissions = {} }) {
  const [collapsed, setCollapsed] = React.useState(true);
  const visibleFields = fields.filter(({ question }) => question.id in permissions);

  if (!visibleFields.length) return null;

  return (
    <Card sx={formCardStyle}>
      <Box position="relative" display="flex" alignItems="center" justifyContent="center" mb={collapsed ? 1 : 0}>
        <Typography align="center" variant="body1" color="info.main">
          {title}
        </Typography>
        <IconButton
          size="small"
          onClick={() => setCollapsed((prev) => !prev)}
          aria-label={`${collapsed ? 'Expand' : 'Collapse'} ${title}`}
          sx={{ color: 'info.main', position: 'absolute', right: 0 }}
        >
          <Iconify icon={collapsed ? 'mdi:chevron-down' : 'mdi:chevron-up'} width={22} />
        </IconButton>
      </Box>
      <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
      {!collapsed && (
        <Grid container spacing={1.5}>
          {visibleFields.map(
            ({ question, title: questionTitle, invoiceFileTypeId, contractFileTypeId, allowMultipleVendors }) => (
              <Grid item xs={12} key={question.id}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle, fieldType: 'title' }} />
                  {allowMultipleVendors ? (
                    <FormVendorFieldWithAddMore
                      fieldName={question.fieldName}
                      fieldAttributes={{ isEditable: permissions[question.id] }}
                      invoiceFileTypeId={invoiceFileTypeId}
                      contractFileTypeId={contractFileTypeId}
                    />
                  ) : (
                    <FormVendorField
                      fieldName={question.fieldName}
                      fieldAttributes={{ isEditable: permissions[question.id] }}
                      invoiceFileTypeId={invoiceFileTypeId}
                      contractFileTypeId={contractFileTypeId}
                    />
                  )}
                </FieldContainer>
              </Grid>
            )
          )}
        </Grid>
      )}
    </Card>
  );
}
